import { KHMCTU_DEFAULT } from "./TaxDeductRegisterConstant";

export const ERROR_CONNECT_TOOL_USB =
  "Lỗi kết nối. Vui lòng kiểm tra lại file kết nối và ấn restart lại";
export const ERROR_GET_INFO_USB =
  "Không lấy dc thông tin USB token. Vui lòng kiểm tra lại USB và ấn Recheck";
export const GET_INFO_USB = "Đang lấy thông tin USB token";

export const FIELD_EXTRA = {
  FIELD_EMPTY: {
    field: "FIELD_EMPTY",
  },
};

// $link_type Đánh dấu trạng thái liên kết điều chỉnh/thay thế 1 => parent replace , 2 => parent adjust , 3 => child replace , 4 => child adjust
export const LINK_TYPE = {
  NORMAL: "NULL",
  PARENT_REPLACE: 1,
  PARENT_ADJUST: 2,
  CHILD_REPLACE: 3,
  CHILD_ADJUST: 4,
};

export const TAX_DEDUCT_COMMON_FIELD = {
  PBAN: {
    field: "pban", // Phiên Bản
    type: "text",
    max: 6,
    disabled: true,
    isHide: true,
    required: false,
  },
  TTCHUNG_THDON: {
    field: "ttchung_thdon", // Tên chứng từ
    type: "text",
    isHide: false,
    disabled: true,
    max: 100,
    required: false,
    isShowLabel: false,
    defaultValue: "CHỨNG TỪ KHẤU TRỪ THUẾ TNCN",
    // xs: 4,
    styleInput: {
      borderBottom: "none",
      fontWeight: "500",
      fontSize: "20px",
      marginLeft: "-9px",
    },
    styleCol: {
      width: "376px",
    },
  },
  TTCHUNG_MSCTU: {
    // xs: 2,
    field: "ttchung_msctu", // Ký hiệu mẫu số chứng từ
    type: "text",
    max: 10,
    required: false,
    disabled: true,
    defaultValue: KHMCTU_DEFAULT,
    widthLabel: "54px",
    styleInput: {
      borderBottom: "none",
      //   marginLeft: "-27px",
      paddingLeft: "0px",
      width: "fit-content",
    },
    styleCol: {
      width: "128px",
    },
  },
  TTCHUNG_KHCTU: {
    // xs: 2,
    field: "ttchung_khctu", // Ký hiệu chứng từ
    type: "text",
    // isKHHD: true,
    max: 9,
    required: true,
    disabled: true,
    widthLabel: "91px",
    styleCol: {
      width: "197px",
    },
    styleInput: {
      borderBottom: "none",
      //   marginLeft: "-27px",
      paddingLeft: "0px",
      width: "fit-content",
    },
  },

  TTCHUNG_SCTU: {
    // xs: 2,
    field: "ttchung_sctu", // Số chứng từ
    type: "text",
    required: false,
    disabled: true,
    widthLabel: "108px",
    defaultValue: "Chờ cấp số",
    styleInput: {
      borderBottom: "none",
      marginLeft: "-27px",
      color: "red",
      width: "fit-content",
    },
    styleCol: {
      width: "197px",
    },
  },
  TTCHUNG_NLAP: {
    // xs: 4,
    field: "ttchung_nlap", // Ngày lập
    type: "date",
    required: true,
    disabled: false,
    marginLeft: "-27px",
    defaultValue: [new Date().setHours(0, 0, 0, 0)],
    styleInput: {
      marginLeft: "-37px",
    },
    styleCol: {
      width: "376px",
    },
  },
  SIGNING_DATE: {
    // xs: 4,
    field: "signing_date", // Ngày ký
    type: "date",
    required: false,
    disabled: true,
    marginLeft: "-27px",
    styleInput: {
      marginLeft: "-37px",
      borderBottom: "none",
    },
    styleCol: {
      width: "376px",
    },
  },

  TTCHUNG_TTKHAC: {
    field: "ttchung_ttkhac", // Thông tin chung khác
    type: "object",
    max: 255,
    isHide: true,
    required: false,
  },
};

// Thông tin tổ chức trả thu nhập
export const TAX_DEDUCT_TCTTNHAP_FIELD = {
  TCTTNHAP_TEN: {
    // xs: 6,
    field: "tcttnhap_ten", // Tên
    type: "text",
    max: 400,
    // disabled: true,
    required: true,
    // isShowLabel: false,
    // defaultValue: "Tên tố chức trả thu nhập",
    // styleInput: {
    //   borderBottom: "none",
    //   fontWeight: "bold",
    //   fontSize: "15px",
    //   marginLeft: "-9px",
    // },
  },
  TCTTNHAP_MST: {
    // xs: 6,
    field: "tcttnhap_mst", // Mã số thuế
    type: "text",
    isTaxCode: true,
    max: 14,
    required: true,
    // styleInput: {
    //   borderBottom: "none",
    //   marginLeft: "-27px",
    //   fontWeight: "600",
    //   letterSpacing: "1px",
    // },
  },
  TCTTNHAP_DCHI: {
    // xs: 6,
    field: "tcttnhap_dchi", // Địa chỉ
    type: "text",
    max: 400,
    // disabled: true,
    required: true,
    // styleInput: {
    //   borderBottom: "none",
    //   marginLeft: "-27px",
    // },
  },
  TCTTNHAP_SDTHOAI: {
    // xs: 4,
    field: "tcttnhap_sdthoai", // Số điện thoại
    type: "text",
    // disabled: true,
    required: true,
    max: 20,
    // styleInput: {
    //   borderBottom: "none",
    // },
  },
  TCTTNHAP_DCTDTU: {
    field: "tcttnhap_dctdtu", // Địa chỉ thư điện tử
    type: "text",
    max: 50,
    // disabled: true,
    required: true,
  },
  TCTTNHAP_TTKHAC: {
    field: "tcttnhap_ttkhac", // Thông tin khác
    type: "text",
    isHide: true,
    max: 255,
    disabled: true,
    required: false,
  },
};

// Thông tin người nộp thuế
export const TAX_DEDUCT_NNT_FIELD = {
  NNT_TEN: {
    field: "nnt_ten", // Tên
    type: "text",
    max: 400,
    // xs: 8,
    widthLabel: "145px",
  },
  NNT_MST: {
    field: "nnt_mst", // Mã số thuế
    isTaxCode: true,
    type: "text",
    max: 14,
    widthLabel: "145px",
    required: true,
    // xs: 4,
  },
  NNT_DCHI: {
    field: "nnt_dchi", // Địa chỉ
    type: "text",
    max: 400,
    // xs: 4,
    widthLabel: "145px",
    required: true,
  },
  NNT_QTICH: {
    field: "nnt_qtich", // Quốc tịch
    type: "text",
    max: 400,
    // xs: 4,
    widthLabel: "145px",
  },
  NNT_CNCTRU: {
    field: "nnt_cnctru", // Cá nhân cư trú
    type: "select",
    max: 1,
    required: true,
    widthLabel: "145px",
    defaultValue: {
      value: 1,
      label: "Cư trú",
    },
    // xs: 4,
  },
  NNT_CCCDAN: {
    field: "nnt_cmnd", // CMND (Số CMND /CCCD/Hộ chiếu)
    type: "text",
    max: 20,
    isCCCD: true,
    // xs: 4,
    required: true,
    widthLabel: "145px",
  },
  // NNT_NGCCMND: {
  //   field: "nnt_ngccmnd", // Ngày cấp CMND (Ngày cấp CMND /CCCD/Hộ chiếu)
  //   type: "date",
  //   required: false,
  //   // xs: 4,
  //   widthLabel: "227px",
  // },
  // NNT_NCCMND: {
  //   field: "nnt_nccmnd", // Nơi cấp CMND (Nơi cấp CMND /CCCD/Hộ chiếu)
  //   type: "text",
  //   max: 100,
  //   // xs: 4,
  //   widthLabel: "227px",
  // },
  NNT_SDTHOAI: {
    field: "nnt_sdthoai", // Số điện thoại
    type: "text",
    required: true,
    max: 20,
    // xs: 4,
    widthLabel: "145px",
  },
  NNT_DCTDTU: {
    field: "nnt_dctdtu", // Địa chỉ thư điện tử
    type: "text",
    isEmail: true,
    max: 50,
    // xs: 4,
    widthLabel: "145px",
  },
  NNT_GCHU: {
    field: "nnt_gchu", // Ghi chú
    type: "text",
    isEmail: true,
    max: 50,
    // xs: 4,
    widthLabel: "145px",
  },
  NNT_TTKHAC: {
    field: "NNT_TTKHAC", // Thông tin khác
    type: "text",
    max: 255,
    isHide: true,
    require: false,
  },
};

// Thông tin thuế TNCN khấu trừ
export const TAX_DEDUCT_TTNCNKTRU_FIELD = {
  TTNCNKTRU_KTNHAP: {
    field: "ttncnktru_ktnhap", // khoản thu nhập
    type: "text",
    max: 250,
    required: true,
    // xs: 12,
    widthLabel: "274px",
    styleInput: {
      width: "261px",
    },
  },
  TTNCNKTRU_TTHANG: {
    field: "ttncnktru_tthang", // Từ tháng (Tháng bắt đầu trả thu nhập)
    type: "select",
    max: 400,
    required: true,
    // xs: 4,
    widthLabel: "274px",
    defaultValue: {
      value: 1,
      label: "Tháng 1",
    },
  },
  TTNCNKTRU_DTHANG: {
    field: "ttncnktru_dthang", // Đến Tháng (Tháng cuối cùng trả thu nhập)
    type: "select",
    max: 400,
    required: true,
    // xs: 4,
    defaultValue: {
      value: 12,
      label: "Tháng 12",
    },
  },
  TTNCNKTRU_NAM: {
    field: "ttncnktru_nam", // Năm (Thời điểm trả thu nhập)
    type: "text",
    max: 4,
    // disabled: true,
    required: true,
    defaultValue: new Date().getFullYear(),
    // xs: 4,
  },
  TTNCNKTRU_BHIEM: {
    field: "ttncnktru_bhiem", // Khoản đóng bảo hiểm bắt buộc
    type: "text",
    max: 22,
    required: true,
    // xs: 12,
    widthLabel: "274px",
    isThousandSeparator: true,
    styleInput: {
      width: "261px",
    },
    decimalScale: 6,
  },
  TTNCNKTRU_TTHIEN: {
    field: "ttncnktru_tthien", // Khoản từ thiên nhân đạo khuyến học
    type: "text",
    max: 22,
    required: true,
    // xs: 12,
    widthLabel: "274px",
    isThousandSeparator: true,
    styleInput: {
      width: "261px",
    },
    decimalScale: 6,
  },
  TTNCNKTRU_TTNCTHUE: {
    field: "ttncnktru_ttncthue", // Tổng thu nhập chịu thuế phải khấu trừ
    type: "text",
    max: 22,
    required: true,
    // xs: 8,
    widthLabel: "274px",
    styleInput: {
      width: "261px",
    },
    isThousandSeparator: true,
    decimalScale: 6,
  },
  TTNCNKTRU_TTNTTHUE: {
    field: "ttncnktru_ttntthue", // Tổng thu nhập tính thuế
    type: "text",
    max: 22,
    required: true,
    // xs: 8,
    widthLabel: "274px",
    styleInput: {
      width: "261px",
    },
    isThousandSeparator: true,
    decimalScale: 6,
  },
  TTNCNKTRU_STHUE: {
    field: "ttncnktru_sthue", // Số thuế (Số thuế TNCN đã khấu trừ)
    type: "text",
    max: 22,
    required: true,
    // disabled: true,
    // xs: 8,
    widthLabel: "274px",
    styleInput: {
      width: "261px",
    },
    isThousandSeparator: true,
    decimalScale: 6,
  },
  // TTNCNKTRU_STNCDNHAN: {
  //   field: "ttncnktru_stncdnhan", // Số thu nhập còn được nhận
  //   type: "text",
  //   max: 22,
  //   required: false,
  //   // disabled: true,
  //   // xs: 8,
  //   widthLabel: "274px",
  //   styleInput: {
  //     width: "261px",
  //   },
  //   isThousandSeparator: true,
  //   decimalScale: 6,
  // },
  TTNCNKTRU_TTKHAC: {
    field: "ttncnktru_ttkhac", // Thông tin khác
    type: "text",
    max: 255,
    isHide: true,
    require: false,
  },
};
